import { render, staticRenderFns } from "./ChecklistDialog.vue?vue&type=template&id=39dcc132"
import script from "./ChecklistDialog.vue?vue&type=script&lang=js"
export * from "./ChecklistDialog.vue?vue&type=script&lang=js"
import style0 from "./ChecklistDialog.vue?vue&type=style&index=0&id=39dcc132&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39dcc132')) {
      api.createRecord('39dcc132', component.options)
    } else {
      api.reload('39dcc132', component.options)
    }
    module.hot.accept("./ChecklistDialog.vue?vue&type=template&id=39dcc132", function () {
      api.rerender('39dcc132', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/checklists/ChecklistDialog.vue"
export default component.exports